<template>
  <span>
    <modal
      v-if="stage === 1"
      :key="'1'"
      class="modal email-modal"
      @close="$emit('close')"
    >
      <h4 slot="title">{{ $t('changeEmail') }}</h4>
      <section
        slot="body"
        class="popup-section-body"
      >
        <editable-input
          id="email-input-wrapper"
          :ref="'email'"
          v-model="email"
          :title="$t('newEmail')"
          reference="email"
          input-type="email"
          lazy-validation
          :validation-function="emailValid"
          :incorrect-value-msg="$t('enterCorrectEmail')"
          :autofocus="true"
          @focus-out="checkIfCorrect"
        />
        <p class="description">{{ $t('weWillSendYouAnEmailWithAConfirmationLink') }}</p>
        <button
          id="change-button"
          class="clavo-button primary"
          :class="{ 'clavo-button-inactive': !emailFormValid }"
          @click="stage = 2"
        >
          {{ $t('changeEmail') }}
        </button>
      </section>
    </modal>
    <modal
      v-if="stage === 2"
      :key="'2'"
      class="modal password-modal"
      @close="$emit('close')"
    >
      <h4 slot="title">{{ $t('confirmWithYourPassword') }}</h4>
      <section
        slot="body"
        class="popup-section-body"
      >
        <editable-input
          id="password-wrapper"
          v-model="password"
          :title="$t('password')"
          reference="password"
          input-type="password"
          :autofocus="true"
        />
        <p class="description">{{ $t('forSecurityReasons') }}</p>
        <button
          id="confirm-button"
          class="clavo-button primary"
          :class="{ 'clavo-button-inactive': !passwordFormValid }"
          @click="change"
        >
          {{ $t('confirm') }}
        </button>
      </section>
    </modal>
  </span>
</template>

<script>
import Modal from '@/components/Modal'
import EditableInput from '@/components/UI/EditableInput'
import Validation from '@/components/Validation'
import Constants from '@/components/Constants'
import ParseFunctions from '@/components/ParseFunctions'
import EventBus from '@/EventBus'

export default {
  components: {
    Modal,
    EditableInput,
  },
  mixins: [Validation, Constants, ParseFunctions],
  data() {
    return {
      stage: 1,
      email: '',
      password: ''
    }
  },
  computed: {
    emailFormValid() {
      return this.emailValid(this.email)
    },
    passwordFormValid() {
      return this.password !== ''
    },
  },
  methods: {
    checkIfCorrect() {
      if (this.email !== '') this.$refs.email.validate()
    },
    async change() {
      let res
      // console.log('email pass', this.email, this.password)
      try {
        res = await this.changeEmailRequest(this.email, this.password)
        EventBus.$emit('new-info-bar-msg', { msg: this.$t('checkYourEmail') })
      } catch (e) {
        console.error('error try changeemail', JSON.parse(JSON.stringify(e)))
      }

      // console.log('change res', res)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../scss/_general.scss';
.modal {
  @include fade-in-opacity;
}
section {
  display: flex;
  flex-direction: column;
  margin-bottom: 42px;

  p {
    text-align: left;
    margin: 24px 0 0 0;
    padding: 0;
  }

  .disabled {
    color: $bluebell;
  }

  button {
    margin-top: 40px;
  }
}
</style>
